'use strict';

import contactUs from './contactUs/contactUs';

/**
 * Initialize contactUs js assets
 */

const contactUsInit = () => {
    contactUs.init;
};

if (document.readyState === 'loading') {
    document.addEventListener ('DOMContentLoaded', () => {
        contactUsInit();
    }, false);

} else {
    contactUsInit();
}